import FormIdentityProvider from './FormIdentityProvider';
import enhancer from './FormIdentityProvider.enhancer';

export default enhancer(FormIdentityProvider);
